export enum NotificationsListEvents {
    OPEN_NOTIFICATION = 'OPEN_NOTIFICATION',
    READ_NOTIFICATION = 'READ_NOTIFICATION',
}



// WEBPACK FOOTER //
// ./ts/app/notifications-list/types/notifications-list-events.enum.ts